import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustSection } from './components/TrustSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-paper font-sans text-brand-text selection:bg-brand-terracotta/30" data-id="element-0" data-mp="23v2rsz5cwt3a">
      <MetaPixel data-id="element-1" data-mp="3ii4su47vuwpm" />
      <AnnouncementBar data-id="element-2" data-mp="3mlawr57iwbsx" />
      <main data-id="element-3" data-mp="3mkrcviybbdc9">
        <HeroSection data-id="element-4" data-mp="3mk85uxa7a9d0" />
        <StatsBar data-id="element-5" data-mp="3mjq3rk0ux0x6" />
        <TransformationSection data-id="element-6" data-mp="3mj6jhwnqi0fz" />
        <PainPointsSection data-id="element-7" data-mp="3rbzmog3k10py" />
        <KitContentsSection data-id="element-8" data-mp="3rcsy3udgkeef" />
        <InstantAccessSection data-id="element-9" data-mp="3relumgucxi8p" />
        <BonusesSection data-id="element-10" data-mp="6hovayao7c0" />
        <PricingSection data-id="element-11" data-mp="4n53zyrel9i" />
        <GuaranteeSection data-id="element-12" data-mp="56qxrrj5tst" />
        <TrustSection data-id="element-13" data-mp="2zl3cxocsjc6w" />
        <FAQSection data-id="element-14" data-mp="2zlv6yuqqp1v2" />
        <FinalCTASection data-id="element-15" data-mp="2zmenc70qri6z" />
      </main>
      <Footer data-id="element-16" data-mp="2zng2amkvootz" />
    </div>;
}